import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Translatable } from '@app/types/translatable.type';
import { BenefitPlan } from '@models/benefits/benefit-plan.model';

export class CarrierColumn extends Column {
    title: Translatable = 'benefits.planIndex.table.columnHeaders.carrier';
    property = 'benefitProvider';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(object: BenefitPlan): string | null {
        return object.benefitProvider?.name;
    }
}
